import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@bo-client/shared/models/userDto';

@Pipe({
  name: 'hasRole'
})
export class HasRole implements PipeTransform {
  transform(roles: UserRole[], searchRole?: string): boolean {
    const idxareaType = roles.findIndex((x) => x.name == searchRole);
    if (idxareaType == -1) {
      return false;
    } else {
      return true;
    }
  }
}
